import React from "react";
import BaseList from "../../components/BaseList";
import Toggle from "../../components/DataGrid/toggle.js";

const formatarData = (data) => {
  if (!data) return "-";
  const [ano, mes, dia] = data.split('-');
  return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`;
};

const formatarHora = (hora) => {
  if (!hora) return "-";
  return hora.substring(0, 5);
};

const getColumns = ({ podeEditar, onToggleStatus }) => {
  return [
    { field: "loginName", header: "Login SQL", sortable: true },
    {
      key: "dataExcecao",
      header: "Data",
      width: "120px",
      render: (row) => formatarData(row.dataExcecao),
    },
    {
      key: "horaInicio",
      header: "Hora Início",
      width: "100px",
      render: (row) => formatarHora(row.horaInicio),
    },
    {
      key: "horaFim",
      header: "Hora Fim",
      width: "100px",
      render: (row) => formatarHora(row.horaFim),
    },
    { field: "motivo", header: "Motivo" },
    {
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => onToggleStatus(row.id, row.ativo)}
            disabled={!podeEditar}
          />
        </div>
      ),
    },
  ];
};

export default function ExcecaoList() {
  return (
    <BaseList
      titulo="Exceções de Horário"
      subtitulo="Permissões temporárias fora do horário de bloqueio"
      endpoint="excecoes"
      baseRoute="/excecoes"
      getColumns={getColumns}
      permissoes={{
        criar: "excecoes.criar",
        editar: "excecoes.remover",
      }}
      emptyMessage="Nenhuma exceção encontrada"
      novoButtonText="Nova Exceção"
      emptyButtonText="Cadastrar primeira exceção"
      allowRowClick={false}
    />
  );
}